// extracted by mini-css-extract-plugin
module.exports = {"formcontrol":"country_formcontrol__yJBWR"};